module.exports = __webpack_public_path__ + "static/media/mobil_adat.7c078f6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobil_adat.png
// module id = 2564
// module chunks = 0